/* unplugin-vue-components disabled */import { render } from "./LicenseStatement.vue?vue&type=template&id=2833284a&scoped=true&ts=true"
import script from "./LicenseStatement.vue?vue&type=script&lang=ts"
export * from "./LicenseStatement.vue?vue&type=script&lang=ts"

import "./LicenseStatement.vue?vue&type=style&index=0&id=2833284a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2833284a"]])

export default __exports__